import { ISkipApprovalModalState } from './types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { skipApprovalPostsThunk, skipApprovalPostsSocialThunk } from './thunks';
import { APPROVAL_TYPE } from '../../../models/post'

const initialState: ISkipApprovalModalState = {
  is_skip_approval_modal_open:false,
  skipped_approvals:[],
  inProgress:false,
  openApproveModal:false
}

const skipApprovalModaltSlice = createSlice({
  name: 'skipApproval',
  initialState,
  reducers: {
    toggleIsSkipAprrovalModalAction: (state) => {
      state.is_skip_approval_modal_open = !state.is_skip_approval_modal_open
    },
    resetSkipApprovalAction: (state) => {
      state.skipped_approvals = []
    },
    openApproverModalAction: (state,action)=>{
      state.openApproveModal = action.payload
    },
    updateSkipApproverAction: (state, action)=>{
      state.skipped_approvals = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(skipApprovalPostsThunk.pending, (state, action) => {
      state.inProgress = true;
    })
    builder.addCase(skipApprovalPostsThunk.fulfilled, (state, action) => {
      const {approval_plan:{rounds:{internal,external}} } = action.payload.data
      const skippedApproval = [];
      if(internal?.isSkipped){
        skippedApproval.push(APPROVAL_TYPE.TYPE_INTERNAL);
      }
      if(external?.isSkipped){
        skippedApproval.push(APPROVAL_TYPE.TYPE_EXTERNAL);
      }
      state.skipped_approvals = skippedApproval;
      state.inProgress = false;
    })
    builder.addCase(skipApprovalPostsThunk.rejected, (state, action) => {
      state.inProgress = false;
    })

      //Skip during revision
      builder.addCase(skipApprovalPostsSocialThunk.pending, (state, action) => {
        state.inProgress = true;
      })
    
      builder.addCase(skipApprovalPostsSocialThunk.fulfilled, (state, action) => {
        const {approval_plan:{rounds:{internal,external}} } = action.payload.data
        const skippedApproval = [];
        if(internal?.isSkipped){
          skippedApproval.push(APPROVAL_TYPE.TYPE_INTERNAL);
        }
        if(external?.isSkipped){
          skippedApproval.push(APPROVAL_TYPE.TYPE_EXTERNAL);
        }
        state.skipped_approvals = skippedApproval;
        state.inProgress = false;
      })
      builder.addCase(skipApprovalPostsSocialThunk.rejected, (state, action) => {
        state.inProgress = false;
      })
  }
})

export const { toggleIsSkipAprrovalModalAction, resetSkipApprovalAction, openApproverModalAction , updateSkipApproverAction } =
skipApprovalModaltSlice.actions
export default skipApprovalModaltSlice.reducer
